import { __assign, __rest } from "tslib";
import React from 'react';
import { ReactPopperManager as PopperManager } from '../../Popover/PopperPopover/ReactPopper';
import DropdownStateManager from '../DropdownStateManager';
import { PopupContext } from '../../Popup/PopupContext';
import noop from '../../utils/noop';
var PopperDropdownManager = function (_a) {
    var children = _a.children, isInPopup = _a.isInPopup, dropdownProps = __rest(_a, ["children", "isInPopup"]);
    return (React.createElement(DropdownStateManager, __assign({}, dropdownProps), isInPopup ? (React.createElement(PopupContext.Provider, { value: { isInPopup: true, setScrollableContentRef: noop } },
        React.createElement(PopperManager, null, children))) : (React.createElement(PopperManager, null, children))));
};
PopperDropdownManager.displayName = 'PopperDropdownManager';
export default PopperDropdownManager;
//# sourceMappingURL=PopperDropdownManager.js.map